<template>
  <div
    class="card mb-0"
    :class="{'h-100': visible}"
  >
    <div class="card-body">
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <div
            class="back-circle small mr-2 cursor-pointer"
            @click.prevent="visible=!visible"
          >
            <i
              v-if="visible"
              class="fa fa-chevron-up"
            />
            <i
              v-else
              class="fa fa-chevron-down"
            />
          </div>
          <h4 class="d-inline-block mb-0">
            {{ $t('vendorManagementRequestChart.tdarkMracitlri') }}
          </h4>
        </div>
        <div class="text-right">
          {{ $t('vendorManagmentPuchaseChart.son30Gn') }}
          <span class="text-primary"> {{ $t('vendorManagementRequestChart.mracit', {requests30Days: requests30Days}) }} </span>
        </div>
      </div>

      <div
        v-show="visible"
        class=" mt-3"
      >
        <div class="m-2 text-left ">
          <div
            v-for="d in chartData.datasets"
            :id="`checkbox_${d.label}`"
            class="mr-3 d-inline-block "
          >
            <i
              class="fa fa-circle mr-1"
              :style="{color: d.backgroundColor } "
            />
            <span>{{ d.label }}</span>
          </div>
        </div>

        <Bar
          v-if="ready"
          id="vendor-request-chart"
          :chart-options="options"
          :chart-data="chartData"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {
  getFormSectorStatistics,
} from "@/repositories/VendorManagementRepository";


import {Bar} from 'vue-chartjs'
import {Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)


export default {

  components: {Bar},
  data() {
    return {
      mediaBase: mediaBase,
      sectorVendorStatistics: [],
      requests30Days: 0,
      ready: false,
      visible: true
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),
    options() {
      return {
        responsive: true,
        aspectRatio: 16 / 9,
        interaction: {
          intersect: false,
          mode: 'index',
        },
        scales: {
          y: {
            beginAtZero: true,
            min: 0,
            suggestedMax: 3,
            ticks: {
              stepSize: 1
            }
          },

          x: {
            ticks: {
              display: true,
              autoSkip: false,
              maxRotation: 90,
              callback: (index) => {
                return this.chartData.labels[index].slice(0, 20) + '...';
              }
            }
          }
        },
        plugins: {
          legend: {
            display: false
          }
        }
      };
    },
    chartData() {

      let data = {
        labels: [],
        datasets: [
          {
            label: this.$t("vendorManagementChart.requestChart.label1"),
            backgroundColor: '#45B79D',
            data: [],
            yAxisID: 'y',
            borderRadius: {
              topLeft: Number.MAX_VALUE,
              topRight: Number.MAX_VALUE
            },
          },
          {
            label: this.$t("vendorManagementChart.requestChart.label2"),
            backgroundColor: '#EBBE5F',
            data: [],
            yAxisID: 'y',
            borderRadius: {
              topLeft: Number.MAX_VALUE,
              topRight: Number.MAX_VALUE
            },
          },
          {
            label: this.$t("vendorManagementChart.requestChart.label3"),
            backgroundColor: '#8B4E7F',
            data: [],
            yAxisID: 'y',
            borderRadius: {
              topLeft: Number.MAX_VALUE,
              topRight: Number.MAX_VALUE
            },
          },
          {
            label: this.$t("vendorManagementChart.requestChart.label4"),
            backgroundColor: '#6E8DE2',
            data: [],
            yAxisID: 'y',
            borderRadius: {
              topLeft: Number.MAX_VALUE,
              topRight: Number.MAX_VALUE
            },
          },
          {
            label: this.$t("vendorManagementChart.requestChart.label5"),
            backgroundColor: '#E06C6C',
            data: [],
            yAxisID: 'y',
            borderRadius: {
              topLeft: Number.MAX_VALUE,
              topRight: Number.MAX_VALUE
            },
          },
        ]
      };


      this.sectorVendorStatistics.forEach((s) => {
        data.labels.push(s.sectorName);
        data.datasets[0].data.push(s.vendorCount);
        data.datasets[1].data.push(s.waitingFormCount);
        data.datasets[2].data.push(s.returnedFormCount);
        data.datasets[3].data.push(s.expiredFormCount);
        data.datasets[4].data.push(s.rejectedFormCount);

      })


      return data;

    }

  },
  mounted() {


    this.getFormFormSectorStatistics();

  },
  methods: {


    getFormFormSectorStatistics() {

      getFormSectorStatistics(this.token).then(({code, statistics, requests30Days}) => {
        if (code === 200) {
          this.sectorVendorStatistics = statistics;
          this.ready = true;
          this.requests30Days = requests30Days;
        }
      })

    },

  }

}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
